import { Link } from 'react-router-dom';

const footerLinks = {
  Services: [
    { label: 'Webapps', to: '/services' },
    { label: 'Mobile Apps', to: '/services' },
    { label: 'Microservices', to: '/services' },
    { label: 'AWS Expertise', to: '/services' },
    { label: 'EKS / Kubernetes', to: '/services' },
    { label: 'Observability', to: '/services' },
  ],
  Company: [
    { label: 'About', to: '/about' },
    { label: 'Blog & Case Studies', to: '/blog' },
    { label: 'Contact', to: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/legal/privacy' },
    { label: 'Terms of Use', to: '/legal/terms' },
    { label: 'Cookies', to: '/legal/cookies' },
    { label: 'Accessibility', to: '/legal/accessibility' },
    { label: 'Security', to: '/legal/security' },
    { label: 'SLA & Disclaimers', to: '/legal/sla' },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A222C] text-gray-300 border-t border-[#334155]">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                thought
              </span>
              <span className="text-xl font-bold text-[#FF9900]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                basics
              </span>
              <span className="text-[#FF9900] text-xl font-bold">.</span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              We partner with IT companies to design, deliver, and operate production systems that scale.
            </p>
            <p className="text-sm text-gray-400 mt-4">
              admin@thoughtbasics.com
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Bengaluru, India
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-xs tracking-[0.2em] uppercase font-semibold text-gray-400 mb-4"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm text-gray-400 hover:text-[#FF9900] transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-[#334155] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Thoughtbasics. All rights reserved.
          </p>
          <button
            data-testid="footer-cookie-settings"
            onClick={() => {
              localStorage.removeItem('tb_consent_v1');
              window.dispatchEvent(new Event('consent-reset'));
            }}
            className="text-sm text-gray-500 hover:text-[#FF9900] transition-colors duration-200"
          >
            Cookie settings
          </button>
        </div>
      </div>
    </footer>
  );
}
